/**
 * 在pc端打开手机端链接时的重定向处理
 */

import { routeMap,createMobileRouteMap } from './routeMap'
 
 /**
  * 根据当前平台页面的querystring，构建对应平台的页面querystring
  * @param {*} targetQueryMap 
  * @param {*} query 当前平台页面的参数
  * @returns 页面查询字符串
  */
 function createTargetQuerystring(targetQueryMap,query){
 
   const keys = Object.keys(targetQueryMap);

   if(keys.length == 0) {
     return '';
   }
 
   const newQuery = {};
 
   keys.forEach(key => {
     const valueKey = targetQueryMap[key];
     const value = query[valueKey];
     newQuery[key] = value;
   })
 
   const querystring = Object.keys(newQuery).reduce((string,current) => {
     return `${string}&${current}=${newQuery[current]}`
   },'');
 
   return `?${querystring.slice(1)}`;
 
 }
 

 /**
  * 根据当前的pc路由信息构建对应手机端的页面地址
  */

 export function routeToMobile(vueRoute) {

  const targetURL = process.env.VUE_APP_MOBILE_REDIRECT_URL;

  const routeMap = createMobileRouteMap();

  const {path,query} = vueRoute;

  const targetRoute = routeMap[path];
 
   if(!targetRoute) {
     return `${targetURL}/`;
   }
 
   const {targetPath,targetQueryMap} = targetRoute;
   
   const targetQuerystring = createTargetQuerystring(targetQueryMap,query);
 
   const mobildURL = `${targetURL}${targetPath}${targetQuerystring}`;
 
   return mobildURL;
 }


// WEBPACK FOOTER //
// ./src/config/mobileRedirection.js